import {
    createApp
} from 'vue'
import App from './App.vue'

import '@/assets/style.scss'

import Dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import locale_zh from 'dayjs/locale/zh';

const app = createApp(App);

app.config.globalProperties.$date = Dayjs;
// update dayjs extentions here to take effect
app.config.globalProperties.$date.locale(locale_zh);
app.config.globalProperties.$date.extend(localizedFormat);
app.config.globalProperties.$date.extend(relativeTime);

app.mount('#app')